import { APP_PERMISSIONS } from '@exam-center/permission';
import { ProctorRequestCreationButton } from '@exam-center/proctor-request-creation';
import {
  ProctorRequestList,
  ProctorRequestListFilterSection,
  ProctorRequestListNavigationTabs,
  ProctorRequestSummaryStatuses,
} from '@exam-center/proctor-request-list';
import { Divider, Flex, PaperSection } from '@shared/components';
import { PermissionGuard } from '@shared/permissions';

export default function ProctorRequestsPage() {
  return (
    <PermissionGuard requiredPermission={APP_PERMISSIONS.PROCTOR_MANAGEMENT.PROCTOR_REQUEST.VIEW}>
      <PaperSection
        title='รายการยื่นคำขออนุมัติผู้คุมสอบ'
        endAdornment={<ProctorRequestCreationButton />}
      >
        <Flex
          sx={(theme) => ({ flexDirection: 'column', gap: theme.spacing(4), p: theme.spacing(6) })}
        >
          <ProctorRequestSummaryStatuses />
          <ProctorRequestListFilterSection />
          <Flex
            sx={(theme) => ({
              borderRadius: theme.shape.rounded(2),
              border: '1px solid',
              borderColor: theme.palette.grey[200],
              flexDirection: 'column',
              overflow: 'hidden',
              flexGrow: 1,
            })}
          >
            <ProctorRequestListNavigationTabs />
            <Divider
              sx={{
                mt: '-1px',
              }}
            />
            <ProctorRequestList />
          </Flex>
        </Flex>
      </PaperSection>
    </PermissionGuard>
  );
}
